import script from "./packageSucceeds.vue?vue&type=script&setup=true&lang=ts"
export * from "./packageSucceeds.vue?vue&type=script&setup=true&lang=ts"

import "./packageSucceeds.vue?vue&type=style&index=0&id=75663c20&scoped=true&lang=stylus"
import "./packageSucceeds.vue?vue&type=style&index=1&id=75663c20&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75663c20"]])

export default __exports__